module.exports = __webpack_public_path__ + "static/media/security.17687596.svg";